(function($) {
    $(() => {

        /* Interest Mobile Slider */
        $('.js-interest-slider').slick({
            dots: true,
            centerMode: true,
            slidesToShow: 2,
        });
        
        /* Front Page News Slider */
        $('.js-front-news-slider').slick({
            infinite: true,
            arrows: true,
            dots: false,
            centerMode: true,
            slidesToShow: 5,
            appendArrows: $('.js-arrow-wrapper'),
            prevArrow:  $('.js-left-arrow'),
            nextArrow:  $('.js-right-arrow'),
            responsive: [
                {
                    breakpoint: 1920,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                        dots: false,
                        centerMode: false,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                        centerMode: false,
                        infinite: false
                    }
                }
            ]
        });
        

        $('.js-front-news-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
           
            if(currentSlide > nextSlide) {
                $('.js-animate-line').addClass('reverse');
                setTimeout(function() {
                    $('.js-animate-line').removeClass('reverse');
                    
                }, 1000);
            } else {
                
                $('.js-animate-line').addClass('animate');
                setTimeout(function() {
                    $('.js-animate-line').removeClass('animate');
                    
                }, 1000);
            }
        });

        $('.js-front-news-slider').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            if(i < 10) {
                i = '0'+i;
            }
            $('.js-slider-actual').text(i)
            $('.match-h').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
        });


      
       
    });
})(jQuery);
